<template>
  <router-view />
</template>

<script>
import { tenantHelper, jwtHelper, apiHelper, titleLevelHelper } from '@/helpers/index';
import axios from 'axios';

export default {
  created: async function() {
    const tenantId = this.getTenantId();
    const jwtKey = this.getJwtKey();
    tenantHelper.setTenant(tenantId);
    apiHelper.setPath(tenantId);
    if (jwtKey) {
      // if we have a jwt, we use it
      jwtHelper.setJwtKey(jwtKey);
      const jwt = jwtHelper.getJwtFromLocalStorage();
      axios.defaults.headers.common['Authorization'] = `Bearer ${jwt}`;
    } else {
      // if not, use default auth
      axios.defaults.headers.common['Authorization'] = `Basic ${new Buffer('guest:guest').toString('base64')}`;
    }
    try {
      titleLevelHelper.setLevel(this.$route.query.titleLevel);
    } catch (error) {
      this.$log.error(error.message);
      titleLevelHelper.setLevel(0);
    }
  },
  methods: {
    getJwtKey: function() {
      return this.$route.query.jwtKey;
    },
    getTenantId: function() {
      const tenantId = this.$route.params.tenantId;
      if (!tenantId) throw new Error(`The tenant has not been found`);
      return tenantId;
    },
  },
};
</script>
